<template>
  <div class="storeIndexSure">
    <van-row class="cell cell-title">
      <van-row class="border cell-body receipts">
        <van-col span="8" class="title">填写记录</van-col>
      </van-row>
    </van-row>
    <van-row class="cell">
      <van-row class="border cell-body receipts">
        <van-col span="8" class="title">日期</van-col>
        <van-col span="16" class="rightText">{{storeInfo.goodsVoucherTime}}</van-col>
      </van-row>
    </van-row>
    <!-- 收到入库 -->
    <div v-if="handoverType === 'store'">
      <van-row class="cell">
        <van-row class="border cell-body receipts">
          <van-col span="8" class="title">接收人</van-col>
          <van-col span="16" class="rightText">{{storeInfo.receiverName}}</van-col>
        </van-row>
      </van-row>
      <van-row class="cell">
        <van-row class="border cell-body receipts">
          <van-col span="8" class="title">移交人</van-col>
          <van-col span="16" class="rightText">{{storeInfo.transferName}}</van-col>
        </van-row>
      </van-row>
      <van-row class="cell">
        <van-row class="border cell-body receipts">
          <van-col span="8" class="title">移交人电话</van-col>
          <van-col span="16" class="rightText">{{storeInfo.currentPhone}}</van-col>
        </van-row>
      </van-row>
    </div>
    <!-- 归还客户 -->
    <div v-else>
      <van-row class="cell">
        <van-row class="border cell-body receipts">
          <van-col span="8" class="title">移交人</van-col>
          <van-col span="16" class="rightText">{{storeInfo.transferName}}</van-col>
        </van-row>
      </van-row>
      <van-row class="cell">
        <van-row class="border cell-body receipts">
          <van-col span="8" class="title">接收人</van-col>
          <van-col span="16" class="rightText">{{storeInfo.receiverName}}</van-col>
        </van-row>
      </van-row>
      <van-row class="cell">
        <van-row class="border cell-body receipts">
          <van-col span="8" class="title">接收人电话</van-col>
          <van-col span="16" class="rightText">{{storeInfo.currentPhone}}</van-col>
        </van-row>
      </van-row>
    </div>
    <van-row class="cell">
      <van-row class="border cell-body receipts">
        <van-col span="8" class="title">快递单号</van-col>
        <van-col span="16" class="rightText">{{storeInfo.expressNumber}}</van-col>
      </van-row>
    </van-row>

    <div style="margin-top: 0.1rem">
      <van-row class="cell">
        <van-row class="border cell-body receipts">
          <van-col span="8" class="title">客户名称</van-col>
          <van-col span="16" class="rightText">{{storeInfo.customerName}}</van-col>
        </van-row>
      </van-row>
      <div v-if="storeGoodsList.length != 0">
        <div v-for="ite in storeGoodsList" :key="ite.id">
          <van-row class="cell">
            <van-row class="border cell-body receipts">
              <van-col span="12" class="title">
                <div class="title-name">{{ite.goodsName}}</div>
              </van-col>
              <van-col span="12" class="rightText input-content">
                <van-stepper style="height: 0.32rem" v-model="ite.number" disabled button-size="22px" max="9999" input-width="42px" />
              </van-col>
              <van-col span="24" class="text input-content">
                <div class="title-goodsRemarks">物品备注：{{ite.goodsRemarks}}</div>
              </van-col>
            </van-row>
          </van-row>
        </div>
      </div>
    </div>
    <div>
      <div class="labelTitle fs16 border-top fj">附件</div>
      <div class="uploadWrap border-bottom">
        <van-row class="uploadImgRow">
          <van-col class="uploadImgCol" span="8" v-for="(item,index) in fileList" :key="index">
            <img class="uploadImg" :src="item" @click="preImgClick(item, index)">
          </van-col>
        </van-row>
      </div>
    </div>

    <div>
      <van-row class="btnRow">
        <van-col span="24" class="centerText confirmText" @click.native="linkSkip('storeSuccess',{type: handoverType},'','')">确认无误提交</van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Icon, Popup, Toast, Field, DatetimePicker, Uploader, Stepper, ImagePreview } from "vant";

Vue.use(Row)
  .use(Col)
  .use(Icon)
  .use(Popup)
  .use(Field)
  .use(DatetimePicker)
  .use(Uploader)
  .use(Stepper)
  .use(ImagePreview)

export default {
  name: "storeIndexSure",
  components: {},
  data() {
    return {
      handoverType: '', // 交接类型：store收到入库；return归还客户
      storeInfo: {
        goodsVoucherTime: '',
        receiverId: '',
        receiverName: '', // 接收人
        currentPhone: '', // 电话
        transferId: '',
        transferName: '', // 移交人
        expressNumber: '',
        customerName: "", // 客户名称
        customerId: ''
      },
      storeGoodsList: [],
      fileList: [], // 附件
      fileIdList: [], // 附件Id
      imagePreview: null,
      canClick: true // 防止重复点击提交
    };
  },

  methods: {
    getParams () {
      let params = JSON.parse(localStorage.getItem("storeParams"));
      if (params) {
        this.storeInfo = params.storeInfo
        this.storeGoodsList = params.storeGoodsList
        this.fileList = params.fileList
        this.fileIdList = params.fileIdList
      }
    },
    linkSkip (name, params) {
      let self = this
      let storeParams = localStorage.getItem("storeParams");
      let handoverType = this.handoverType
      let storeInfo = this.storeInfo
      if (!storeParams) {
        Toast("请重新填写记录");
        return
      }
      let newList = []
      this.storeGoodsList.forEach((item) => {
        let goodsItem = {
          goodsId: item.goodsId,
          number: item.number,
          goodsRemarks: item.goodsRemarks
        }
        newList.push(goodsItem)
      })
      let query = {}
      let param = {
        customerId: storeInfo.customerId,
        acctGoodsVoucherVO: {
          expressNumber: storeInfo.expressNumber,
          goodsVoucherTime: storeInfo.goodsVoucherTime
        },
        acctGoodsVoucherDetailVOList: newList,
        acctGoodsFileVOList: this.fileIdList,
        accCompanyId: this.$store.state.acctCompanyInfo.accCompanyId
      }
      let url = ''
      if (handoverType === 'store') {
        query.metaName = '收到入库'
        url = '/mini/user/goods/voucher/addNewGoodsVoucher'
        param.acctGoodsVoucherVO.goodsVoucherType = 2
        param.acctGoodsVoucherVO.receiverId = storeInfo.receiverId
        param.acctGoodsVoucherVO.transferName = storeInfo.transferName
        param.acctGoodsVoucherVO.currentPhone = storeInfo.currentPhone
      } else if (handoverType === 'return') {
        query.metaName = '归还客户'
        url = '/mini/user/goods/voucher/revertCustomer'
        param.acctGoodsVoucherVO.goodsVoucherType = 3
        param.acctGoodsVoucherVO.transferId = storeInfo.transferId
        param.acctGoodsVoucherVO.receiverName = storeInfo.receiverName
        param.acctGoodsVoucherVO.currentPhone = storeInfo.currentPhone
      }
      if(!this.canClick){
        Toast("请勿重复提交！");
        return
      }
      this.canClick = false;
      this.$http
        .post(url, param)
        .then(res => {
          if (res.data.code == 200) {
            self.canClick = true;
            query.id = res.data.data
            query.customerId = storeInfo.customerId
            query.handoverType = handoverType
            query.transferName = storeInfo.transferName

            if (handoverType === 'store') {
              window._hmt.push(['_trackEvent', "资料交接", "移动端提交收到入库", self.$store.state.acctCompanyInfo.name + '_' + storeInfo.transferName]);
            } else {
              window._hmt.push(['_trackEvent', "资料交接", "移动端提交归还客户", self.$store.state.acctCompanyInfo.name + '_' + storeInfo.transferName]);
            }
            this.$router.push({
              name: name,
              params: params,
              query: query
            });
            localStorage.removeItem("storeParams")
          } else {
            this.canClick = true;
            Toast(res.data.msg);
          }
        })
        .catch(() => {
          this.canClick = true;
          Toast("服务器错误，请联系账无忧解决!");
        });
    },
    // 附件
    preImgClick(img, index) {
      this.imagePreview = ImagePreview({
        images: this.fileList,
        startPosition: index
      });
    }
  },
  mounted: function() {
    this.handoverType = localStorage.getItem("handoverType");
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    // 获取本地存储的添加物品
    this.getParams()
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.storeIndexSure {
    position: relative;
    padding-bottom: 0.64rem;

    .cell {
        background-color: #ffffff;
        font-size: 0.16rem;
        padding-left: 0.16rem;
        position: relative;
    }

    .cell-body {
        padding: 0.12rem;
        padding-left: 0;
    }

    .cell-title {
        .title {
            color: #1A2633;
            font-size: 0.17rem;
            font-weight: bold;
        }
    }

    .title {
        color: #1A2633;
        font-size: 0.17rem;
    }

    .rightText {
        text-align: right;
        color: #1a2633;
        font-size: 0.14rem;
        line-height: 0.23rem;
    }

    .type {
        margin-top: 0.08rem;
    }

    .border {
        border-bottom: 1px solid #f0f2f2;
    }

    .btnRow {
        text-align: center;
        color: #1FADF6;
        background-color: #ffffff;
        border-top: 1px solid #f0f2f2;
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 0;
        font-size: 0.17rem;
        box-sizing: border-box;
        font-weight: 500;
        line-height: 0.52rem;
    }

    .btnRow.disabled {
        color: #B4BEC7;
    }

    .title-name {
      font-weight: bold;
      font-size: 0.16rem;
      line-height: 0.32rem;
    }
    .title-remark {
      font-size: 0.14rem;
      color: #516374;
      line-height: 0.28rem;
    }
    .title-state {
      font-size: 0.14rem;
      color: #62CA6C;
    }
    .rejection-icon {
      display: inline-block;
      width: 0.6rem;
      height: 0.26rem;
      color: #FAA050;
      border: 1px solid #FAA050;
      border-radius: 0.13rem;
      text-align: center;
      line-height: 0.26rem;
    }
    .mr-t20 {
      margin-top: 0.2rem;
    }
    .centerText {
      color: #516374;
      font-size: 0.14rem;
    }
    .confirmText {
      color: #ffffff;
      height: 0.52rem;
      line-height: 0.52rem;
      background: #1fadf6;
    }
    .input-content {
      input {
        height:0.23rem;
        border:none;
        width: 100%;
        caret-color:#FF5C32;
        color: #1A2633;
        text-align: right;
        font-size: 0.14rem;
      }
    }
    .fj {
      margin-top: 0.1rem;
      height: 0.48rem;
      background: #fff;
      padding-left: 0.16rem;
      line-height: 0.48rem;
    }
    .uploadWrap {
      background: #ffffff;
      padding: 0 0.16rem;

      .uploadImgRow {
        text-align: center;
        padding: 0.08rem 0;
        padding-bottom: 0.2rem;
        .uploadImgCol {
          font-size 0
          position relative
          .imgDeleteBtn{
            font-size 0.2rem
            position: absolute;
            bottom: 0;
            right: 0.1rem;
            padding 0.02rem
            background rgba(0,0,0,0.1);
            color #ffffff
            line-height: 0.2;
          }
        }

        .uploadImg {
          width: 1.04rem;
          height 1.04rem
        }
      }
    }
    .title-goodsRemarks {
      font-size: 0.14rem;
      color: #516374;
      line-height: 0.28rem;
    }
}
</style>
<style>
.storeIndexSure .van-stepper button {
  display: none;
}
.storeIndexSure .van-stepper__minus,
.storeIndexSure .van-stepper__plus {
  border-radius: 0 2px 2px 0;
}
</style>

